export default "__VITE_ASSET__DbBrUTUu__"